import ErrorApi from "./../utils/ErrorApi"
import JsonFetch from "./../utils/JsonFetch"

if (serverContextPath === null) {
    console.error("Global variable serverContextPath is not defined (is null)!");
}

export default class EoApi {
    static baseUrl =            `${serverContextPath}/api`;
    static eo =                  EoApi.baseUrl + '/eo';
    static pracovnici =          EoApi.eo + '/pracovnici';

    // static findPracovniciPravoIsepOpis(fulltext) {
    //     const uri = EoApi.pracovnici;
    //     return ErrorApi.responseResolver(JsonFetch.get(uri, {fulltext}));
    // }

    static findPracovnici(fulltext, proSpustenouAplikaci, max) {
        const uri = EoApi.pracovnici;
        return ErrorApi.responseResolver(JsonFetch.get(uri, {
            fulltext,
            proSpustenouAplikaci,
            max
        }));
    }
}
